"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageForCountry = exports.roundDecimal = void 0;
function roundDecimal(number, digits = 2) {
    return Number(number.toFixed(digits));
}
exports.roundDecimal = roundDecimal;
function getLanguageForCountry(country) {
    const frenchSpeakers = ['FR', 'BE', 'LU'];
    const germanSpeakers = ['DE', 'AT', 'CH', 'LI'];
    const spanishSpeakers = [
        'ES',
        'MX',
        'AR',
        'CO',
        'CL',
        'PE',
        'VE',
        'EC',
        'GT',
        'CU',
        'BO',
        'DO',
        'HN',
        'PY',
        'SV',
        'CR',
        'NI',
        'UY',
        'PA',
    ];
    if (frenchSpeakers.includes(country)) {
        return 'fr';
    }
    else if (germanSpeakers.includes(country)) {
        return 'de';
    }
    else if (spanishSpeakers.includes(country)) {
        return 'es';
    }
    return 'en';
}
exports.getLanguageForCountry = getLanguageForCountry;
//# sourceMappingURL=utils.js.map